<template>
  <span>
    <h1>{{ display }}</h1>
  </span>
</template>
<script>
export default {
  name: 'DisplayEmpty',
  props: {
    length: {
      type: [Number, String],
      required: true
    }
  },
  computed: {
    display() {
      return ''.padStart(+this.length, '-')
    }
  }
}
</script>
